'use client'

import Link from 'next/link'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import { EffectFade, Navigation, Pagination, Scrollbar } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { IBlogPost } from '@/_types'

import ABlogArticleCard from '../../components/a-blog-article-card'

interface ABlogPostRelatedBlogsProps {
	blogPost: IBlogPost
}

const ABlogPostRelatedBlogs = ({ blogPost }: ABlogPostRelatedBlogsProps) => {
	return (
		<section id='akcie' className='bg0 pdt-100 pdt-60lg pdb-100 pdb-60lg pos_rel'>
			<div className='wrapper'>
				<div className='section_head'>
					<h2 className='title_side text_uc'>Súvisiace články</h2>
				</div>
			</div>
			<ABlogPostRelatedBlogsNavigation />

			<div className='swiper-offers-cont cursordrag mgt-40 mgt-30lg'>
				<Swiper
					modules={[Navigation, Pagination, Scrollbar, EffectFade]}
					slidesPerView={1.5}
					breakpoints={{
						768: {
							slidesPerView: 2.8
						}
					}}
					spaceBetween={20}
					loop={false}
					speed={1000}
					grabCursor={true}
					centeredSlides={false}
					navigation={{
						nextEl: '.swiper-next',
						prevEl: '.swiper-prev',
						enabled: true
					}}
					pagination={{
						el: '.swiper-pagination',
						type: 'fraction',
						clickable: true,
						enabled: true
					}}
					scrollbar={{
						el: '.slider-custom-scrollbar',
						hide: false,
						draggable: true,
						enabled: true
					}}
					className='swiper-container  slider-custom swiper-carousel'
				>
					{blogPost?.relatedPosts.map(article => (
						<SwiperSlide
							key={article.id}
							className='max-w-[280px] sm:max-w-none flex-shrink-0'
						>
							<ABlogArticleCard article={article} />
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</section>
	)
}

export default ABlogPostRelatedBlogs

export const ABlogPostRelatedBlogsNavigation: React.FC = () => {
	return (
		<div className='swiper_controls_side hide_lgm'>
			<Link
				href='#'
				title='Predchádzajúci'
				className='btn_circle toleft swiper-prev'
				prefetch={false}
			>
				<span>
					<svg className='sico'>
						<use href='/assets/layout/icons.svg#s_ar2_l' />
					</svg>
				</span>
				<span>
					<svg className='sico'>
						<use href='/assets/layout/icons.svg#s_ar2_l' />
					</svg>
				</span>
			</Link>

			<Link href='#' title='Následujúci' className='btn_circle swiper-next' prefetch={false}>
				<span>
					<svg className='sico'>
						<use href='/assets/layout/icons.svg#s_ar2_r' />
					</svg>
				</span>
				<span>
					<svg className='sico'>
						<use href='/assets/layout/icons.svg#s_ar2_r' />
					</svg>
				</span>
			</Link>
		</div>
	)
}
